import { Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getPermissions } from '../../app/util';
import { UPDATE_STATE } from "../../actions/types";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const AnalyticsReportsButton = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const state = useSelector((appState) => appState);
    const {
        profile: { property_details },
        user,
    } = useSelector((state) => state.auth);

    const { app_state, ui_state } = useSelector(
        (state) => state.app.current_state
    );

    const { property_id } = app_state;
    const { permissions } = getPermissions(property_details, property_id);



    const handleAnalyticsReport = (id) => {
        const { property_id, property_name, workspace_controls, primary_stay_range } = app_state;
        const formatted_stay_date = moment().format('YYYY-MM-DD');//dateFormat(moment(), "YYYY-MM-DD");
        window.analyze.track("Sigma_Analytics_Report", {
            "selected_tile": ui_state.active_tiles.join(),
            property_id, property_name,
            "Stay Date": formatted_stay_date
        }, {}, {
            app_state: {
                workspace_controls,
            },
            ui_state: {
            }
        });
        dispatch({
            type: UPDATE_STATE,
            payload: {
                app_state: {
                    workspace_controls: {
                        ...app_state.workspace_controls,
                        // sigmaDashboard: true,
                        sigma_report_id: id,
                        sigmaDashboardUrl: ''
                    },
                },
            }
        });

        setTimeout(()=>{
            navigate("/analytics-reports");
        },1000)
    }

    let propVarient = property_details.find((propertyEle) => propertyEle.id === property_id)?.product_variant;
    let sigmaReportsArr = propVarient?.ea_reports;
    // const exists = sigmaReportsArr.find(item => item.id.includes(ui_state.active_tiles[0]));
    const exists = sigmaReportsArr[0];
    let reportId = '';
    let label = '';
    if (permissions && permissions.ea && exists && exists.id) {
         reportId = exists.id;
    }else{
        return "";
    }

    return (
        <Tooltip followCursor title={label}>
           <div className={props.isDisabled ? 'btn-analytics-new-badge disabled' : 'btn-analytics-new-badge'}>NEW</div>
            <Button disabled={props.isDisabled} className="btn-analytics-report" onClick={() => handleAnalyticsReport(reportId)}>
                <svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1270_4333)">
                        <path d="M10.7209 9.75328C10.6012 9.75328 10.4816 9.70661 10.3988 9.61328C10.2147 9.43595 10.2147 9.13728 10.3988 8.95061L13.316 5.99194C13.3988 5.90794 13.5184 5.85194 13.638 5.85194C13.7577 5.85194 13.8773 5.89861 13.9601 5.99194L15.2853 7.33594L17.9172 4.66661C18.1012 4.47994 18.3865 4.47994 18.5706 4.66661C18.7546 4.85328 18.7546 5.14261 18.5706 5.32928L15.6166 8.32528C15.4325 8.51194 15.1472 8.51194 14.9632 8.32528L13.638 6.98128L11.0522 9.61328C10.9601 9.70661 10.8405 9.75328 10.7301 9.75328H10.7209Z" fill="white" />
                        <path d="M6.6626 0.466553V4.82522H0.460144V2.21189C0.460144 1.24122 1.22395 0.466553 2.1718 0.466553H6.6626Z" fill="#679BD4" />
                        <path d="M6.6626 4.82544H0.460144V9.17477H6.6626V4.82544Z" fill="#14B793" />
                        <path d="M6.6626 9.17456V13.5332H2.1718C1.22395 13.5332 0.460144 12.7586 0.460144 11.7879V9.17456H6.6626Z" fill="#9F4296" />
                        <path d="M6.66258 0H2.17178C0.97546 0 0 0.989333 0 2.212V11.788C0 13.0107 0.97546 14 2.17178 14H6.66258C6.92025 14 7.1227 13.7947 7.1227 13.5333V0.466667C7.1227 0.205333 6.92025 0 6.66258 0ZM0.920245 5.292H6.20245V8.708H0.920245V5.292ZM0.920245 2.212C0.920245 1.50267 1.4816 0.933333 2.17178 0.933333H6.20245V4.35867H0.920245V2.212ZM6.20245 13.0667H2.17178C1.4816 13.0667 0.920245 12.4973 0.920245 11.788V9.64133H6.20245V13.0667Z" fill="white" />
                        <path d="M18.8282 14H8.13499C7.87732 14 7.67487 13.7947 7.67487 13.5333V0.466667C7.67487 0.205333 7.87732 0 8.13499 0H18.8282C20.0246 0 21.0092 0.989333 21.0092 2.212V11.7973C21.0092 13.0107 20.0338 14.0093 18.8282 14.0093V14ZM8.59511 13.0667H18.8282C19.5184 13.0667 20.089 12.4973 20.089 11.788V2.212C20.089 1.512 19.5276 0.933333 18.8282 0.933333H8.59511V13.0667Z" fill="white" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1270_4333">
                            <rect width="21" height="14" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <div>Business Intelligence</div>
            </Button>
        </Tooltip >
    )
}

export default AnalyticsReportsButton
